import Phaser from "phaser";
import { TICK_TIME } from "../utils/constants";
import LevelFinale from "./levels/level_finale";
import LevelKiFinale from "./levels/level_ki_finale";

export default class Rules {
  constructor(scene) {
    this.scene = scene;
    // gravity loop
    this.timer = 0;
    this.worldTickFreq = TICK_TIME;
    // scene.events.removeListener(Phaser.Scenes.Events.UPDATE, this.onSceneUpdate)
    scene.events.on(Phaser.Scenes.Events.UPDATE, this.onSceneUpdate.bind(this));

    // this.setUpPuseResumeGame()
    // this.setUpCameraFollow()
    scene.events.off("levelcompleted");
    scene.events.on("levelcompleted", (result) => {
      scene.events.emit("sounds:level_complete");
      scene.tweens.add({
        targets: this.music,
        volume: 1,
        ease: "Linear",
        duration: 500,
        onComplete: () => {
          this.music.stop();
        },
      });
      scene.cameras.main.fade(3000, 0, 0);
      scene.cameras.main.once("camerafadeoutcomplete", () => {
        scene.scene.start("LevelResumeScene", {
          level: scene.levels.current.constructor.key,
          ...result,
        });
        // scene.levels.current.cleanLevel()
        // scene.levels.next()
        // scene.cameras.main.fadeIn(1000, 0, 0)
      });
    });
    scene.events.removeListener("levelstart", this.onLevelStart.bind(this));
    scene.events.addListener("levelstart", this.onLevelStart.bind(this));
  }
  destroy() {
    this.music?.stop();
    // this.music.destroy()
    this.scene.events.off(Phaser.Scenes.Events.UPDATE);
    this.scene.events.off("levelstart");
  }
  onLevelStart() {
    this.setUpCameraFollow();
    if (this.scene.levels.current.id === LevelKiFinale.key) {
      this.music = this.scene.sound.add("levels_surface", {
        loop: true,
        valume: 0,
      });
      if(!this.scene.isRestart) {
        this.music.play();
        this.scene.tweens.add({
          targets: this.music,
          volume: 1,
          ease: "Linear",
          duration: 500,
        });
      }
    } else {
      this.music = this.scene.sound.add("levels_surface", {
        loop: true,
        valume: 0,
      });
      this.music.play();
      this.scene.tweens.add({
        targets: this.music,
        volume: 1,
        ease: "Linear",
        duration: 500,
      });
    }
  }

  async setUpCameraFollow(target = { x: 0, y: 0, width: 1, height: 1 }) {
    const cam = this.scene.cameras.main;
    
    cam.startFollow(target, false, 0.05, 0.05);
    await this.panAndFollow(this.scene.levels.current.focusObject)
    this.scene.levels.current.resume();
  }

  panAndFollow(target){
    return new Promise(res => {
      const cam = this.scene.cameras.main;
      cam.pan(
        target.x,
        target.y,
        // this.scene.levels.current.player.alien.x,
        // this.scene.levels.current.player.alien.y,
        TICK_TIME * 8,
        Phaser.Math.Easing.Cubic.InOut,
        null,
        (camera, progress) => {
          if (progress === 1) {
            camera.startFollow(
              target,
              // this.scene.levels.current.player.alien,
              true,
              0.05,
              0.05
            );
            res()
          }
        }
      );
    })
  }

  onSceneUpdate(time, delta) {
    this.timer += delta;
    if (this.timer >= this.worldTickFreq) {
      while (this.timer > this.worldTickFreq) {
        this.timer -= this.worldTickFreq;
      }
      this.scene.levels.current.gravityLoop();
    }
  }

  calcCompletion(
    gems,
    collectedGems,
    enemies,
    killedEnemies,
    shrooms,
    colectedShrooms
  ) {
    const levelCompleted = 1;
    const comp =
      (collectedGems + killedEnemies + colectedShrooms + levelCompleted) /
      (gems + enemies + shrooms + levelCompleted);
    return Math.round(comp * 100) / 100;
  }
}
